import { Modal, Form, Input, Switch } from "antd";
import { useState } from "react";
import "./AddEmployeeModal.css";

const AddEmployeeModal = ({ open, onCancel, onCreate }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await onCreate(values);
      form.resetFields();
    } catch (err) {
      alert(err?.response?.data || "Greška prilikom kreiranja korisnika");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      wrapClassName="addemployee"
      open={open}
      title="Dodaj novog zaposlenog"
      onCancel={onCancel}
      onOk={handleOk}
      confirmLoading={submitting}
      okText="Kreiraj"
      cancelText="Otkaži"
    >
      <Form form={form} layout="vertical">
        <Form.Item name="ime" label="Ime" rules={[{ required: true, message: "Unesite ime" }]}>
          <Input />
        </Form.Item>
        <Form.Item name="prezime" label="Prezime" rules={[{ required: true, message: "Unesite prezime" }]}>
          <Input />
        </Form.Item>
        <Form.Item name="korisnickoIme" label="Korisničko ime" rules={[{ required: true, message: "Unesite korisničko ime" }]}>
          <Input />
        </Form.Item>
        <Form.Item name="email" label="Email" rules={[{ type: "email", required: true, message: "Unesite validan email" }]}>
          <Input autoComplete="new-email" />
        </Form.Item>
        <Form.Item name="lozinka" label="Privremena lozinka" rules={[{ required: true, message: "Unesite lozinku" }]}>
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="aktivan" label="Aktivan" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEmployeeModal;